export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Alennuskoodeja ja lahjakortteja ei voi yhdistää muihin alennuksiin. Tarjouksen ja pisteiden lunastuksen voi käyttää yhdessä. Automaattiset alennukset, kuten noutoalennus, ovat silti voimassa.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Alennuskoodeja ja lahjakortteja ei voi yhdistää muihin alennuksiin.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Avattu',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Ei voi yhdistää alennuskoodeihin tai lahjakortteihin.',
    promo: 'Ei voi yhdistää tarjouksiin, lahjakortteihin tai pisteisiin.',
    gift: 'Ei voi yhdistää tarjouksiin, alennuskoodeihin tai pisteisiin.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'Alennuskoodi on käytössä. Tämän tarjouksen käyttäminen poistaa sen.',
    offer_blocked_by_gift: 'Lahjakortti on käytössä. Tämän tarjouksen käyttäminen poistaa sen.',
    offer_blocked_by_points: 'Pisteiden lunastus on käytössä. Tämän tarjouksen käyttäminen poistaa sen.',
    promo_gift_displaces_offer: 'Alennuskoodin tai lahjakortin käyttäminen poistaa aktiivisen tarjouksesi.',
    promo_gift_displaces_points: 'Alennuskoodin tai lahjakortin käyttäminen poistaa pisteiden lunastuksen.',
    promo_gift_displaces_offer_and_points:
      'Alennuskoodin tai lahjakortin käyttäminen poistaa aktiivisen tarjouksesi ja pisteiden lunastuksen.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Tämä {{kind}} on jo käytössä: {{name}} ({{saving}}).',
    active_line_no_saving: 'Tämä {{kind}} on jo käytössä: {{name}}.',
    candidate_line: '{{kind}} säästää {{saving}}.',
    only_one: 'Voit käyttää vain yhtä.',
    best_choice: 'Paras valinta',
    keep: 'Säilytä {{label}}',
    use_instead: 'Käytä sen sijaan {{label}}',
    kinds: {
      offer: 'tarjous',
      promo: 'alennuskoodi',
      gift: 'lahjakortti',
      points: 'pisteiden lunastus',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'tarjous',
      promo: 'koodi',
      gift: 'lahjakortti',
      points: 'pisteet',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} on jo käytössä. Tilauksessa voi käyttää vain yhtä alennusta — käytä tätä tarjousta sen sijaan tai sulje tämä ikkuna säilyttääksesi koodisi.',
    active_named: {
      promo: 'Alennuskoodi {{name}} ({{saving}})',
      gift: 'Lahjakortti ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Alennuskoodi {{name}}',
      gift: 'Lahjakortti',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Sinulla on {{count}} aktiivista tarjousta: {{first}} ({{firstValue}}) ja {{second}} ({{secondValue}}) — yhteensä {{total}}. Alennuskoodi {{code}} säästää {{codeValue}} tässä tilauksessa. Vain yhtä voi käyttää.',
    active_offers_more:
      'Sinulla on {{count}} aktiivista tarjousta: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) ja {{more}} muuta — yhteensä {{total}}. Alennuskoodi {{code}} säästää {{codeValue}} tässä tilauksessa. Vain yhtä voi käyttää.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Saatavilla nyt',
    applied: 'Käytössä · {{savings}} alennus',
    applied_plain: 'Käytössä',
    replaces: 'Ei voi yhdistää kohteeseen {{label}} · Korvaa kohteen {{name}}',
    replaces_no_name: 'Ei voi yhdistää kohteeseen {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Ei voi yhdistää kohteeseen {{name}}',
    replaces_name: 'Korvaa kohteen {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Ei voi yhdistää {{count}} aktiiviseen tarjoukseesi',
    replaces_offers: 'Korvaa {{count}} aktiivista tarjousta ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'tarjouksen',
      promo: 'alennuskoodin',
      gift: 'lahjakortin',
      points: 'pisteiden lunastuksesi',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} käytössä. Tämä poisti kohteen {{removed}}.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Alennuskoodi {{code}} ({{codeValue}}) käytössä. Tämä poisti {{count}} tarjousta: {{first}} ja {{second}} ({{total}}).',
      gift: 'Lahjakortti käytössä. Tämä poisti {{count}} tarjousta: {{first}} ja {{second}} ({{total}}).',
    },
    undo: 'Kumoa',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Tarjous {{name}}',
      promo: 'Alennuskoodi {{code}}',
      gift: 'Lahjakortti',
      points: '{{count}} pistettä',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: '{{name}}-tarjouksen',
      promo: '{{code}}-alennuskoodin',
      gift: 'lahjakortin',
      points: 'pisteiden lunastuksesi',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Pisteiden käyttäminen poistaa alennuskoodin {{name}} (–{{saving}})',
      gift: 'Pisteiden käyttäminen poistaa lahjakortin (–{{saving}})',
      promo_no_saving: 'Pisteiden käyttäminen poistaa alennuskoodin {{name}}',
      gift_no_saving: 'Pisteiden käyttäminen poistaa lahjakortin',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo: '{{points}} pistettä käytetty (–{{pointsSaving}}). Alennuskoodi {{name}} (–{{couponSaving}}) poistettiin.',
      gift: '{{points}} pistettä käytetty (–{{pointsSaving}}). Lahjakortti (–{{couponSaving}}) poistettiin.',
      promo_no_saving: '{{points}} pistettä käytetty (–{{pointsSaving}}). Alennuskoodi {{name}} poistettiin.',
      gift_no_saving: '{{points}} pistettä käytetty (–{{pointsSaving}}). Lahjakortti poistettiin.',
    },
  },
};
